// import Vue from 'vue'
// import axios from 'axios'
// import VueAxios from 'vue-axios'
// Vue.use(axios)
// Vue.use(VueAxios)
import axios from '@/plugins/axios'

export default {
  install(Vue) {
    Vue.prototype.$financialStatementApiService = {
      financial_statement_api_url: `${process.env.VUE_APP_EPAPER_API_URL}/financial-statements`,

      /**
       * 查詢
       * @param {string} param - API 查詢參數
       * @returns {Promise<Object>} API 回傳的資料結構
       */
      async query(param = '') {
        const url = `${this.financial_statement_api_url}`
        const params = param ? `?${param}` : ''
        const response = await axios.get(`${url}${params}`)
        return response.data
      },

      /**
       * 取得年份清單
       * @returns {Promise<Object>} API 回傳的資料結構
       */
      async getListOfYear() {
        const response = await axios.get(`${this.financial_statement_api_url}/year`)
        return response.data
      }
    }
  }
}
